import { render, staticRenderFns } from "./CardProject.vue?vue&type=template&id=334e55a6&scoped=true&"
import script from "./CardProject.vue?vue&type=script&lang=js&"
export * from "./CardProject.vue?vue&type=script&lang=js&"
import style0 from "./CardProject.vue?vue&type=style&index=0&id=334e55a6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334e55a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VDialog,VProgressCircular})
